import { DAY_TYPE, startYear } from './Datepicker.consts';

export type MonthChunkedByWeek = {
  id: number;
  className: string;
};

export const getMonthDaysChunkedByWeek = (month: number, year: number): MonthChunkedByWeek[][] => {
  const allDays = getMonthDays(month, year);
  const chunkedArray = [];
  for (let i = 0; i < allDays.length; i += 7) {
    chunkedArray.push(allDays.slice(i, i + 7));
  }
  return chunkedArray;
};

export const getMonthDays = (month: number, year: number): MonthChunkedByWeek[] => {
  const firstDay = getFirstDayOfMonth(year, month);
  const daysInMonth = numOfDaysInMonth(year, month);
  const daysInPrevMonth = numOfDaysInMonth(year, month - 1);
  const startDayIndex = firstDay === 0 ? 6 : firstDay - 1; // Starting from Monday

  const components: MonthChunkedByWeek[] = [];
  let dayCounter = daysInPrevMonth - startDayIndex + 1;

  // Previous month
  for (let i = 0; i < startDayIndex; i++) {
    components.push({ id: dayCounter, className: 'disabled-day prev-month' });
    dayCounter++;
  }

  // Current month
  for (let i = 1; i <= daysInMonth; i++) {
    components.push({ id: i, className: '' });
    dayCounter++;
  }

  // Next month
  const remainingDays = (Math.floor(components.length / 7) + 1) * 7 - components.length;
  for (let i = 1; i <= remainingDays; i++) {
    components.push({ id: i, className: 'disabled-day next-month' });
  }
  return components;
};

export const numOfDaysInMonth = (year: number, month: number) => {
  const date = new Date(year, month, 0);
  return date.getDate();
};

export const getFirstDayOfMonth = (year: number, month: number) => {
  const firstDay = new Date(year, month - 1, 1);
  return firstDay.getDay();
};

export const getLastDayOfMonth = (year: number, month: number, daysInMonth: number) => {
  const lastDay = new Date(year, month - 1, daysInMonth);
  return lastDay.getDay();
};

export const getCurrentDay = () => {
  const currentDate = new Date();
  return currentDate.getDate();
};

export const getCurrentMonth = () => {
  const currentDate = new Date();
  return currentDate.getMonth() + 1;
};

export const getCurrentYear = () => {
  const currentDate = new Date();
  return currentDate.getFullYear();
};

export const getAllYears = () => {
  const years = [];
  const lastYear = getCurrentYear();
  for (let currYear = startYear; currYear <= lastYear; currYear++) {
    years.push(currYear);
  }
  return years;
};

export const getDayType = (className: string): DAY_TYPE => {
  return className.includes('next-month')
    ? DAY_TYPE.NEXT_MONTH
    : className.includes('prev-month')
    ? DAY_TYPE.PREV_MONTH
    : DAY_TYPE.CURRENT_MONTH;
};

export const isDayDisabled = (className: string): boolean => {
  return className.includes('disabled-day');
};

export const detectMonthAndYear: (
  dayType: DAY_TYPE,
  selectedMonth: number,
  selectedYear: number
) => {
  month: number;
  year: number;
} = (dayType, selectedMonth, selectedYear) => {
  let month = selectedMonth + dayType;
  let year = selectedYear;

  if (month > 12 || month < 1) {
    month = month > 12 ? 1 : 12;
    year = selectedYear + dayType;
  }

  return { month, year };
};
